import React, { useLayoutEffect } from 'react';
import cn from "classnames";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import style from "./common.module.scss";
import { useTranslation } from "react-i18next";
import { useScreenSize } from '../../../hooks/useScreenSize';

const OrderCompletionPieChart = ({ item }) => {
    const { isMobileView } = useScreenSize();
    const { t } = useTranslation();

    useLayoutEffect(() => {
        const root = am5.Root.new("chartdiv-pie");
        root.setThemes([am5themes_Animated.new(root)]);
        root._logo.dispose();

        const chart = root.container.children.push(
            am5percent.PieChart.new(root, {
                layout: root.verticalLayout
            })
        );

        const series = chart.series.push(
            am5percent.PieSeries.new(root, {
                valueField: "value",
                categoryField: "category",
                alignLabels: true
            })
        );

        if (isMobileView) {
            series.setAll({
                startAngle: -90,
                endAngle: 270
            });
            series.labels.template.setAll({
                text: "{value}",
                radius: 0,
            });
        } else {
            series.setAll({
                startAngle: 0,
                endAngle: 360
            });
             series.labels.template.setAll({
                text: "{category}: {value}",
            });
        }

        const total = item.success + item.failure;

        series.data.setAll([
            {
                category: t("analytics.onTime"),
                value: item.success,
                color: am5.color(0x84C08C)
            },
            {
                category: t("analytics.late"),
                value: item.failure,
                color: am5.color(0xD85140)
            }
        ]);

        series.slices.template.adapters.add("fill", (fill, target) => {
            return target.dataItem?.dataContext?.color || fill;
        });

        series.slices.template.adapters.add("stroke", (stroke, target) => {
            return target.dataItem?.dataContext?.color || stroke;
        });

        return () => {
            root.dispose();
        };
    }, [item, isMobileView]);

    return (
        <div className={style.content}>
            <div className={style.filter}>
                <span className={style.filter_title}>{t("analytics.completingOrderOnTime")}</span>
            </div>
            {isMobileView && (
                <div className={style.labels}>
                    <span>
                        {t("analytics.onTime")}: {item.success}
                    </span>
                    <span>
                        {t("analytics.late")}: {item.failure}
                    </span>
                </div>
            )}

            <div className={style.area}>
                <div id="chartdiv-pie" className={cn(style.area_chart, {[style.area__chartPie]: isMobileView} ) }></div>
            </div>
        </div>
    );
};

export default OrderCompletionPieChart;
